<template>
    <div ref="pendingProductsDialog">
        <app-dialog :title="tb('Produtos Pendentes')" :width="getDialogWidth" max-width="95vw" :height="getDialogHeight" v-bind="{ ...$attrs }" :value="isPendingProductsDialogOpen" @input="$emit('input', $event)" :isPersistent="true">
            <template v-slot:content>
                <pending-products in-dialog :model="model" :schema="schema" :headers="headers" :details_headers="details_headers"></pending-products>
            </template>

            <template v-slot:buttons="{}">
                <div ref="dialogFooter">
                    <v-btn text class="myprovet-btn-ok px-8" @click="confirm" data-cy="confirm-pending-products"> {{ $t('shippingCosts.next') }} </v-btn>
                </div>
            </template>
        </app-dialog>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useBranchStore } from '@/Stores/branch';

export default {
    props: {
        isPendingProductsDialogOpen: {
            type: Boolean,
            default: false,
        },

        model: [Object, Array],
        schema: [Object, Array],
        headers: [Object, Array],
        details_headers: [Object, Array],
    },

    computed: {
        ...mapStores(useBranchStore),

        getDialogWidth() {
            return this.getResponsiveDialogWidth('95vw', '75vw');
        },

        getDialogHeight() {
            return this.getResponsiveDialogHeight('75vh', '80vh');
        },
    },

    methods: {
        confirm() {
            const client_number = this.branchStore.branch?.client_number;
            const company_branch = this.branchStore.branch?.company_branch;

            this.$inertia.visit(`/orders/normal/summary/${client_number}/${company_branch}`);
        },
    },
};
</script>
